/// <reference path="../_references.ts"/>

module App.User {
	export class UserMenuController extends App.Utils.MenuItemController {
		static $inject = ['$state', '$rootScope', '$timeout', '$q', 'UserSession', 'PermissionService'];

		public menuOptions: App.MenuItem[] = [];

		protected overlay: Element;
		protected drawer: Element;
		public isClocking: boolean = false;
		public showTimeClock: boolean = false;
		public showDashboard: boolean = false;
		public showDispatchSummary: boolean = false;
		public showingMenu: boolean = false;
		public showTimeEvents: boolean = false;
		public showChat: boolean = false;
		public userDisplayName: string = '';

		constructor(
			$state: ng.ui.IStateService,
			$rootScope: App.Administrative.AppRootScope,
			protected $timeout: ng.ITimeoutService,
			protected $q: ng.IQService,
			public UserSession: UserSession,
			protected PermissionService: App.Helpers.PermissionService
		) {
			super($state);

			$rootScope.app.showTimeEvents = () => { this.showTimeEvents = true; };

			this.overlay = document.createElement('div');
			this.overlay.classList.add('mdl-layout__obfuscator-right');


			this.overlay.addEventListener('click', () => this.toggleVisible());
			this.$timeout(() => {
				const drawer = document.querySelector('.mdl-layout__drawer-right-button');

				if (drawer) {
					drawer.addEventListener('click', () => this.toggleVisible());
				}
			});
			this.$timeout(() => {
				const layout = document.querySelector('.mdl-layout');

				if (layout) {
					layout.appendChild(this.overlay);
				}
			}, 200);

			UserSession.getUser().then((user: User) => {
				this.userDisplayName = user.first_name + ' ' + user.last_name;
			});

			this.menuOptions = [
				{
					title: 'Messages',
					action: this.toggleChat.bind(this),
					permission: 'web.field.right-nav.messages',
				},
				{
					title: 'Dashboard',
					action: this.toggleDashboard.bind(this),
					permission: 'web.field.right-nav.stats',
				},
				{
					title: 'Time Clock',
					action: this.toggleTimeClock.bind(this),
					permission: 'web.field.right-nav.time-clock',
				},
				{
					title: this.PermissionService.hasPermission('web.field.right-nav.time-clock')
						? 'Time Clock (new)'
						: 'Time Clock',
					action: this.toggleTimeEvents.bind(this),
					permission: 'web.time-clock.field.view',
				},
				{
					title: 'Dispatch Summary',
					action: this.toggleDispatchSummary.bind(this),
					permission: 'web.field.right-nav.dispatch-summary',
				},
				{
					title: 'Rachel\'s Place',
					uiSref: 'zipSolutions.template-store',
					cssClass: 'pinkText',
					permission: 'web.field.right-nav.template-store',
				}
			];
		}

		private getDrawer(): Element {
			return this.drawer || (this.drawer = document.querySelector('.mdl-layout__drawer-right'));
		}

		toggleVisible(): void {
			if (this.showTimeClock || this.showTimeEvents) return;
			this.showingMenu = !this.showingMenu;
			this.getDrawer().classList.toggle('is-visible');
			this.overlay.classList.toggle('is-visible');
		}

		hide(): void {
			this.getDrawer().classList.remove('is-visible');
			this.overlay.classList.remove('is-visible');
		}

		toggleTimeClock(): ng.IPromise<boolean> {
			this.showTimeClock = !this.showTimeClock;
			return this.$q.when(this.showTimeClock);
		}

		toggleTimeEvents(): ng.IPromise<boolean> {
			this.showTimeEvents = !this.showTimeEvents;
			return this.$q.when(this.showTimeEvents);
		}

		toggleDashboard(): ng.IPromise<boolean> {
			this.showDashboard = !this.showDashboard;
			return this.$q.when(this.showDashboard);
		}

		toggleDispatchSummary(): ng.IPromise<boolean> {
			this.showDispatchSummary = !this.showDispatchSummary;
			return this.$q.when(this.showDispatchSummary)
		}

		menuActionComplete(item: MenuItem): void {
			this.hide();
		}

		toggleChat(): ng.IPromise<boolean> {
			this.showChat = !this.showChat;
			return this.$q.when(this.showChat);
		}
	}
}
